export default __webpack_public_path__ + "pdf.worker.jsload";